import type { ErrorSummaryItem } from '@/components/public/forms/ErrorSummary';

export function buildErrorSummaryItems(
  errors: Record<string, string | undefined>,
  labels: Record<string, string>,
  hrefFor?: (key: string) => string | undefined,
): ErrorSummaryItem[] {
  return Object.entries(errors)
    .filter((entry): entry is [string, string] => Boolean(entry[1]))
    .map(([key, message]) => ({
      key,
      label: labels[key] ?? key,
      message,
      href: hrefFor?.(key),
    }));
}
